import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import { SVG_ICONS } from '../../../constants';

const FIELD_NAMES = {
  ENABLED: 'enabled',
  VALUE: 'value'
};

const ConfigurationRow = ({
  configuration,
  rowIndex,
  rowBeingEditted,
  errors,
  hasPermissionToUpdate,
  updateInputs,
  updateSelectedRow,
  saveChanges,
  cancelChanges,
}) => (
  <tr
    key={configuration.param}
    className={`table-style__row ${rowBeingEditted === rowIndex ? 'edit-row' : ''}`}
    disabled={rowBeingEditted !== null && rowBeingEditted !== rowIndex}
  >
    <td>{configuration.param}</td>
    <td>
      <div className="input-value" style={{ width: '100%', height: '100%'}}>{Number.isNaN(Number(configuration.value)) ? configuration.value : Number(configuration.value)?.toFixed(2)}</div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <input
          className={`table-style__row-input table-style__row-input--hidden mx-3 text-center
                    ${errors?.[configuration.param] ? 'table-style__row-input--error' : ''}
                `}
          style={{ width: '100%' }}
          value={typeof configuration.value === 'number' ? Number(configuration.value).toFixed(2) : configuration.value}
          name={`value-${rowIndex}`}
          onChange={(e) => updateInputs(e.target.value, rowIndex, FIELD_NAMES.VALUE)}
        />
      </div>
      {errors?.[configuration.param] && (<div>
        <div className="form__msg form__msg--error dialog__input-error-txt">
          {errors[configuration.param]}
        </div>
      </div>)}
    </td>
    <td>{configuration.description}</td>
    <td>
      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={configuration.enabled === 1}
          onChange={(e) => updateInputs(e.target.checked ? 1 : 0, rowIndex, FIELD_NAMES.ENABLED)}
          disabled={rowBeingEditted !== rowIndex}
        />
        <span className="toggle-switch__slider" />
      </label>
    </td>
    {hasPermissionToUpdate && (
      <td>
        <div className="d-flex justify-content-center">
          <div
            className="option-btn"
            onClick={() => updateSelectedRow(rowIndex)}
          >
            <span>Change Settings</span>
          </div>
          <div className="action">
            <div className="action-wrap">
              <div
                className="action__btn action__btn--approve"
                onClick={saveChanges}
              >
                <SVGComponent src={`${SVG_ICONS.utility}#tick1`} />
              </div>
              <div
                className="action__btn action__btn--cancel"
                onClick={cancelChanges}
              >
                <SVGComponent src={`${SVG_ICONS.utility}#close-w`} />
              </div>
            </div>
          </div>
        </div>
      </td>
    )}
  </tr>
);

export default ConfigurationRow;